export const validateRequired = (value) => {
  return value ? undefined : 'ui-tenant-settings.settings.validation.required';
};

export const validateEmail = (value) => {
  if (!value) return 'ui-tenant-settings.settings.validation.required';
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value) ? undefined : 'ui-tenant-settings.settings.validation.email';
};

export const validatePort = (value) => {
  if (!value) return 'ui-tenant-settings.settings.validation.required';
  const port = parseInt(value, 10);
  if (isNaN(port) || port < 1 || port > 65535) {
    return 'ui-tenant-settings.settings.validation.port';
  }
  return undefined;
};

export const validateHost = (value) => {
  if (!value) return 'ui-tenant-settings.settings.validation.required';
  const hostRegex = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
  return hostRegex.test(value) ? undefined : 'ui-tenant-settings.settings.validation.host';
};

export const composeValidators = (...validators) => (value) => {
  return validators.reduce((error, validator) => error || validator(value), undefined);
};